<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="GenerateMeterConsumptions"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <p
        class="mb-0 pb-0"
      >
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <ItpText
          wrap
        >
          {{ 'Create consumption records from the readings available in the system between the start and end dates.'|pgettext('GenerateMeterConsumptions') }}
        </ItpText>
      </p>
    </ItpAlert>
    <ItpForm
      :id="formId"
      :name="formName"
      ref="mainForm"
      @submit="evh_4186377094414664_submit($event, {})"
    >
      <ItpFormGroup
        name="min_date"
        :label="'Start date'|pgettext('GenerateMeterConsumptions')"
        :labelAlign="labelAlign"
        label-cols-md="3"
        content-cols-md="4"
        required
      >
        <ItpFormDatetime
          name="min_date"
          type="date"
          v-model="item.min_date"
          required
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="max_date"
        :label="'End date'|pgettext('GenerateMeterConsumptions')"
        :labelAlign="labelAlign"
        label-cols-md="3"
        content-cols-md="4"
        required
      >
        <ItpFormDatetime
          name="max_date"
          type="date"
          v-model="item.max_date"
          required
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="exact_period"
        :label="'Exact period'|pgettext('GenerateMeterConsumptions')"
        :description="'Assign the specified dates as the consumption periods, even if they differ from the reading dates.'|pgettext('GenerateMeterConsumptions')"
        :labelAlign="labelAlign"
        labelColsMd="3"
        contentColsMd="9"
      >
        <ItpFormCheckbox
          name="exact_period"
          inline
          v-model="item.exact_period"
          :readonly="item.isReadOnly"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Generate'|pgettext('GenerateMeterConsumptions|Submit')"
      :form="formId"
      type="submit"
      variant="primary"
      icon="fa-save"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class GenerateMeterConsumptions extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_item = new ComponentValueCache(this, "item", "GenerateMeterConsumptions.item");
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  formName!: any;
  item!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'formName', 'item', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        formName: "GenerateMeterConsumptions",
        item: {
          min_date: null,
          max_date: null,
          meters: null,
          contracts: null,
          rentals: null,
          companies: null,
          tenants: null,
          exact_period: false,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("GenerateMeterConsumptions|Title", "Generate Consumptions"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3410_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3410, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_closeComponent_3412_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_2248226175642056_closeComponent_3412, alias=undefined
    return {
      result: {
        cancel: true,
      }
      ,
    }
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_closeComponent_3414_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_4186377094414664_closeComponent_3414, alias=submit
    return {
      result: {
        close: true,
        ok: true,
        value: this.item,
      }
      ,
    }
  }

  async evh_4186377094414664_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3410: actions.CloseModalAction;
    evh_7315092382398562_close_3409: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3412: actions.CloseComponentAction;
    evh_2248226175642056_close_3411: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_4186377094414664_closeComponent_3414: actions.CloseComponentAction;
    evh_4186377094414664_submit_3413: actions.EventHandlerImpl;
    evh_4186377094414664_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_3416: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_3415: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3410 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3410_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3409 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3410,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3409],
      }
    );
    const act_2248226175642056_closeComponent_3412 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_2248226175642056_closeComponent_3412_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_close_3411 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3412,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3411],
      }
    );
    const act_4186377094414664_closeComponent_3414 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_4186377094414664_closeComponent_3414_getActionArgs,
        displayName: "submit",
        events: [],
      }
    );
    const evh_4186377094414664_submit_3413 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_closeComponent_3414,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_4186377094414664_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_submit_3413],
      }
    );
    const act_1419464017721962_closeComponent_3416 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3415 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_3416,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3415],
      }
    );
    return {
      act_7315092382398562_closeModal_3410,
      evh_7315092382398562_close_3409,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3412,
      evh_2248226175642056_close_3411,
      evh_2248226175642056_close,
      act_4186377094414664_closeComponent_3414,
      evh_4186377094414664_submit_3413,
      evh_4186377094414664_submit,
      act_1419464017721962_closeComponent_3416,
      evh_1419464017721962_clickPreventStop_3415,
      evh_1419464017721962_clickPreventStop,
      submit: act_4186377094414664_closeComponent_3414,
    }
  }
}

Vue.component("GenerateMeterConsumptions", GenerateMeterConsumptions);

</script>